<template>
  <v-dialog
      v-if="current"
      fullscreen
      v-model="dialog"
      persistent
  >
    <v-card>
      <template v-slot:title>
        <v-text-field
            density="compact"
            variant="outlined"
            :label="current.report_description === '' || current.report_description === null ? 'Название отчёта' : null"
            single-line
            hide-details
            v-model="current.report_description"
            @click:append-inner="delete_section()"
        />
        <v-divider />
        <v-textarea
            label="Пояснительная записка"
            density="compact"
            variant="outlined"
            v-model="current.description_note"
        />
      </template>
      <template v-slot:default>
        <div class="d-flex align-center justify-center">
          <ChartHandler mode="dialog" :current="current" size="tall" :title="true"/>
        </div>
      </template>
      <template v-slot:actions>
        <v-spacer />
        <v-tooltip>
          <template v-slot:default>
            Данный отчёт уже просмотрен!
          </template>
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" density="compact" variant="text" v-if="current.watched === true" :icon="['fas', 'eye']">
              <v-icon :icon="['fas', 'eye']" />
            </v-btn>
          </template>
        </v-tooltip>

        <v-tooltip>
          <template v-slot:default>
            <span v-if="!current['description_note']">Пояснительная записка пустая!</span>
            <span v-else>Пояснительная записка заполнена!</span>
          </template>
          <template v-slot:activator="{ props }">
            <v-btn v-bind="props" :icon="['fas', 'file-lines']" density="compact" variant="text">
              <v-icon v-if="!current.description_note" color="#FF5722" :icon="['fas', 'triangle-exclamation']" />
              <v-icon v-else color="#8BC34A" :icon="['fas', 'file-lines']" />
            </v-btn>
          </template>
        </v-tooltip>

        <v-btn density="compact" variant="tonal" v-on:click="closeDialogus()" rounded>
          ПРИМЕНИТЬ
        </v-btn>
      </template>
    </v-card>
  </v-dialog>
</template>

<script>
import { CurrentData, CurrentDialog } from "@/store/report/CurrentDialogData";
import { ExternalData } from "@/store/dev/DEV_Components";
import ChartHandler from "@/components/Reports/ChartHandler.vue";

export default {
  name: "RepDialog_Component",
  components: {ChartHandler},
  methods: {
    closeDialogus: function () {
      this.current.watched = true
      this.current = null
    }
  },
  computed: {
    dialog: {
      get() {
        return CurrentDialog().get()
      },
      set(value) {
        CurrentDialog().set(value)
      }
    },
    external_data: {
      get() {
        return ExternalData().get()
      },
      set(value) {
        ExternalData().set(value)
      }
    },
    current: {
      get() {
        return CurrentData().get()
      },
      set(value) {
        CurrentData().set(value)
      }
    }
  }
}
</script>

<style scoped>

</style>